module.exports = __webpack_public_path__ + "static/img/car8.6d42134.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/car8.jpeg
// module id = 4aMH
// module chunks = 0